export default __webpack_public_path__ + "static/media/cursor.a4e88e2f.svg";